import type { Href } from "expo-router";
import { router } from "expo-router";
import { useEffect } from "react";
import { View } from "react-native";

import { PANE_THEMES } from "../../../components/brand/paneThemes";

const THEME = PANE_THEMES.Admin;

/**
 * /admin/security used to render the TOTP + sessions surface. That content
 * moved to /admin/account, reachable from the avatar dropdown in the
 * AdminShell topbar. This route is kept around as a compatibility redirect
 * for anyone with the old URL bookmarked.
 */
export default function AdminSecurityRedirect() {
  useEffect(() => {
    router.replace("/admin/account" as Href);
  }, []);
  return <View style={{ flex: 1, backgroundColor: THEME.pageBg }} />;
}
